

export const documentLogs = [
    "MISCELLANEOUS_OPERATION",
    "PURCHASE_INVOICE",
    "EXPENSE_REPORT",
    "SALES_INVOICE",
    "ZTILL_RECEIPT",
    "PAY_SLIP",
    "VAT",
    "CURRENT_ACCOUNT",
    "OPERATOR_ACCOUNT",
    // "CARRY_FORWARD"  ->  Supprimé par Noëlle
]
